import BaseView from '../../../js/base-view';

export default class ProgramCard extends BaseView {
	init() {
		this.bindEvents();
	}

	bindEvents() {
		this.on('click', '[data-spotify-url], [data-soundcloud-url]', this.handleListenClick.bind(this));
	}

	handleListenClick(event) {
		event.preventDefault();
		const button = event.target;

		const spotifyUrl = button.getAttribute('data-spotify-url');
		const soundcloudUrl = button.getAttribute('data-soundcloud-url');

		let embedUrl = null;
		let platform = null;

		if (spotifyUrl) {
			embedUrl = this.convertSpotifyToEmbed(spotifyUrl);
			platform = 'spotify';
		} else if (soundcloudUrl) {
			embedUrl = this.convertSoundcloudToEmbed(soundcloudUrl);
			platform = 'soundcloud';
		}

		if (embedUrl) {
			const customEvent = new CustomEvent('program-widget:load', {
				detail: { embedUrl, platform },
				bubbles: true,
			});
			document.dispatchEvent(customEvent);
		}
	}

	convertSpotifyToEmbed(url) {
		if (url.includes('/embed/')) {
			return url;
		}

		const match = url.match(/open\.spotify\.com\/(track|album|playlist|artist)\/([a-zA-Z0-9]+)/);
		if (match) {
			return `https://open.spotify.com/embed/${match[1]}/${match[2]}?utm_source=generator&theme=0`;
		}

		return url;
	}

	convertSoundcloudToEmbed(url) {
		if (url.includes('w.soundcloud.com/player')) {
			return url;
		}

		const match = url.match(/soundcloud\.com\/([^/?]+\/[^/?]+)/);
		if (match) {
			const cleanUrl = 'https://soundcloud.com/' + match[1];
			return `https://w.soundcloud.com/player/?url=${encodeURIComponent(cleanUrl)}&color=%23141414&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true`;
		}

		return url;
	}
}
